import { formatAdminDate } from "./admin-time";

const SEC = 1000;
const MIN = 60 * SEC;
const HOUR = 60 * MIN;
const DAY = 24 * HOUR;

export function formatRelativeTime(when: Date | string, now: Date): string {
  const t = when instanceof Date ? when : new Date(when);
  const diff = now.getTime() - t.getTime();

  if (diff < MIN) return `${Math.max(0, Math.floor(diff / SEC))}s`;
  if (diff < HOUR) return `${Math.floor(diff / MIN)}m`;
  if (diff < DAY) return `${Math.floor(diff / HOUR)}h`;
  if (diff < 30 * DAY) return `${Math.floor(diff / DAY)}d`;

  // Older than 30 days: the admins' (IST) calendar day.
  return formatAdminDate(t);
}
